import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const EditAccountDialog = ({ open, onOpenChange, editForm, setEditForm, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[var(--tg-surface)] border-[var(--tg-border)] text-[var(--tg-strong)] max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-head">Edit Account</DialogTitle>
        <DialogDescription className="text-[var(--tg-faint)]">
          Change the label or stored credentials. The session is preserved. Changing the
          phone or API details may require a fresh Connect to re-initialise the session.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 mt-2">
        <div className="space-y-2">
          <Label className="label-caps">Label</Label>
          <Input data-testid="edit-acc-label" value={editForm.label} onChange={(e) => setEditForm({ ...editForm, label: e.target.value })} className="bg-[var(--tg-bg)] border-[var(--tg-border)]" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-2">
            <Label className="label-caps">API ID</Label>
            <Input data-testid="edit-acc-api-id" value={editForm.api_id} onChange={(e) => setEditForm({ ...editForm, api_id: e.target.value })} className="bg-[var(--tg-bg)] border-[var(--tg-border)] font-mono" />
          </div>
          <div className="space-y-2">
            <Label className="label-caps">Phone</Label>
            <Input data-testid="edit-acc-phone" value={editForm.phone} onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })} className="bg-[var(--tg-bg)] border-[var(--tg-border)] font-mono" />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="label-caps">API Hash</Label>
          <Input data-testid="edit-acc-api-hash" value={editForm.api_hash} onChange={(e) => setEditForm({ ...editForm, api_hash: e.target.value })} placeholder="Leave blank to keep the current hash" className="bg-[var(--tg-bg)] border-[var(--tg-border)] font-mono" />
        </div>
        <Button onClick={onSave} className="w-full bg-[var(--c-sky)] hover:bg-[var(--c-sky-hover)] text-white font-semibold" data-testid="edit-acc-save">
          Save Changes
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
